import { FC } from 'react';
import { Box } from '@mui/material';

import { CircleTextSVG } from '@core/features/artworks/components/CircleTextSVG';
import { useEditorStore } from './EditorStore';

export const DecorationOverlay: FC = () => {
  const { cropAreaCoordinates, cropAreaSize, decoration } = useEditorStore();

  const left = cropAreaCoordinates.x;
  const top = cropAreaCoordinates.y;
  const width = cropAreaSize.width;
  const height = cropAreaSize.height;

  // circleDiameter={cropAreaSize.width}
  // circleCenterX={cropAreaSize.width / 2}
  // circleCenterY={cropAreaSize.height / 2}

  return (
    <>
      <Box
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          left: left,
          top: top,
          width: width,
          height: height,
          userSelect: 'none',
        }}
      >
        {decoration && decoration.text && (
          <CircleTextSVG text={decoration.text.toUpperCase()} />
        )}

        {decoration && decoration.thumbnail && (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              left: 0,
              top: 0,
              maskImage: 'url(/circle_mask.svg)',
            }}
            component={'img'}
            src={decoration?.thumbnail}
          />
        )}
      </Box>

      {/* <Box
        sx={{
          position: 'absolute',
          top: top + height / 2,
          left: 0,
          right: 0,
          height: 2,
          backgroundColor: 'red',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: 0,
          bottom: 0,
          height: '100%',
          width: 2,
          backgroundColor: 'red',
        }}
      /> */}
    </>
  );
};
